import SearchOrganicPaidOverviewDataFetcherFactory from "app/components/widget/widget-fetchers/SearchOrganicPaidOverviewDataFetcher";
import { PieChartWidget } from "app/components/widget/widget-types/PieChartWidget";

export class SearchOrganicPaidOverviewPieChartWidget extends PieChartWidget {
    static getWidgetMetadataType() {
        return "SearchOrganicPaidOverviewPieChart";
    }

    static getWidgetResourceType() {
        return "PieChart";
    }

    static getWidgetDashboardType() {
        return "PieChart";
    }

    constructor() {
        super();
    }

    private dataFetcherFactory() {
        return SearchOrganicPaidOverviewDataFetcherFactory;
    }

    public getFetcherFactory() {
        return this.dataFetcherFactory();
    }

    public async getChartSeries(unorderedData, compareItemsKeys?: string[]): Promise<any[]> {
        const series = [];
        const widgetViewData = this.viewData;
        const widgetViewOptions = this.viewOptions;
        const seriesColors = this._highchartsConfig.chartColors(widgetViewOptions.twoColorMode);
        const key = widgetViewData.key[0].name;
        const dataArrays = unorderedData[key];
        if (!dataArrays) {
            seriesColors.shift();
        }

        Object.entries(dataArrays).forEach(([seriesName, seriesArray]) => {
            seriesName = this.getSeriesName(seriesName);
            const seriesColor = seriesColors.shift();

            series.push(
                Object.assign({
                    name: seriesName,
                    seriesName,
                    color: seriesColor,
                    marker: {
                        symbol: "circle",
                    },
                    data: this.formatSeries(seriesArray),
                    y: seriesArray,
                }),
            );
        });

        const seriesObj = {
            name: key,
            data: series,
        };
        return [seriesObj];
    }
}

SearchOrganicPaidOverviewPieChartWidget.register();
